import { WMCodesLookupLayout } from '../../../../common/lookups/Layouts/WMLayouts';

// User Code 1 lookup — sources from WMCODES where CODETYPE = '87'. The lookup
// framework handles the API call internally via its own params.
const userCodeLookup = WMCodesLookupLayout({ codeType: '87' });

// Search-filter layout for the Edit Serial Number Records screen. Mirrors the
// six left-side fields from the legacy Find panel: Serial #, Customer, Item, Lot,
// In Trans #, Out Trans #.
export const SearchLayout = [
    {
        groupId: 1,
        fields: [
            {
                name: "serialNumber",
                tableName: "WMSERIALNUMBER",
                label: "Serial #",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "customer",
                tableName: "WMSERIALNUMBER",
                label: "Customer",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
           
        ],
    },
    {
        groupId: 2,
        fields: [
            {
                name: "lot",
                tableName: "WMSERIALNUMBER",
                label: "Lot",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "inTransactionNum",
                tableName: "WMSERIALNUMBER",
                label: "In Trans #",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
           
        ],
    },
    {
        groupId: 3,
        fields: [
            {
                name: "outTransactionNum",
                tableName: "WMSERIALNUMBER",
                label: "Out Trans #",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            }, {
                name: "item",
                tableName: "WMSERIALNUMBER",
                label: "Item",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
        ],
    },
];

export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "WMSERIALNUMBER",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "SERIALNUMBER",
                "tableName": "WMSERIALNUMBER",
                "label": "Serial Number",
                "type": "text",
                "required": true,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PACKAGEID",
                "tableName": "WMSERIALNUMBER",
                "label": "Package ID",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "CUSTOMER",
                "tableName": "WMSERIALNUMBER",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "ITEMCODE",
                "tableName": "WMSERIALNUMBER",
                "label": "Item",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "LOTCODE",
                "tableName": "WMSERIALNUMBER",
                "label": "Lot",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "SUBLOTCODE",
                "tableName": "WMSERIALNUMBER",
                "label": "Sublot",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Weights",
        "fields": [
            {
                "name": "NETWEIGHT",
                "tableName": "WMSERIALNUMBER",
                "label": "Net Weight",
                "type": "number",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "GROSSWEIGHT",
                "tableName": "WMSERIALNUMBER",
                "label": "Gross Weight",
                "type": "number",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "ORIGINALNETWEIGHT",
                "tableName": "WMSERIALNUMBER",
                "label": "Or. Net Wt",
                "type": "number",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "ORIGINALGROSSWEIGHT",
                "tableName": "WMSERIALNUMBER",
                "label": "Or. Gross Wt",
                "type": "number",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "In - Transaction Header",
        "fields": [
            {
                "name": "INTRANSACTIONNUM",
                "tableName": "WMSERIALNUMBER",
                "label": "In - Trans #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "INTRANSACTIONDT",
                "tableName": "WMSERIALNUMBER",
                "label": "In - Trans Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Out - Transaction Header",
        "fields": [
            {
                "name": "OUTTRANSACTIONNUM",
                "tableName": "WMSERIALNUMBER",
                "label": "Out - Trans #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "OUTTRANSACTIONDT",
                "tableName": "WMSERIALNUMBER",
                "label": "Out - Trans Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export const AdditionalLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERCODE",
                "tableName": "WMSERIALNUMBER",
                "label": "User Code",
                "type": "lookup",
                "layout": userCodeLookup,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REFERENCE1",
                "tableName": "WMSERIALNUMBER",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REFERENCE2",
                "tableName": "WMSERIALNUMBER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REFERENCE3",
                "tableName": "WMSERIALNUMBER",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REFERENCE4",
                "tableName": "WMSERIALNUMBER",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REFERENCE5",
                "tableName": "WMSERIALNUMBER",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DAMAGEFLAG",
                "tableName": "WMSERIALNUMBER",
                "label": "Damaged",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DAMAGEDESCRIPTION",
                "tableName": "WMSERIALNUMBER",
                "label": "Dmgd Desc",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RECEIPTVERIFIED",
                "tableName": "WMSERIALNUMBER",
                "label": "Rcpt Verified",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SHIPMENTVERIFIED",
                "tableName": "WMSERIALNUMBER",
                "label": "Shp Verified",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SIZE1",
                "tableName": "WMSERIALNUMBER",
                "label": "Size - 1",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SIZE2",
                "tableName": "WMSERIALNUMBER",
                "label": "Size - 2",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "COMMENT",
                "tableName": "WMSERIALNUMBER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "BARCODELABEL",
                "tableName": "WMSERIALNUMBER",
                "label": "Barcode Lbl",
                "type": "text",
                "required": false,
                "maxLength": 50,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
     
];
